import React, { createContext, useContext, useState, useEffect } from "react";
import { getDatabase, ref, set, onValue, push, update, remove } from "firebase/database";
import { uploadFile } from "../config/uploadFile";
import { app } from "../config/firebaseConfig";

const db = getDatabase(app);
const PageDataContext = createContext();

export const PageDataProvider = ({ children }) => {
  // State for dynamic pages
  const [pages, setPages] = useState([]);

  // Fetch pages
  useEffect(() => {
    const pagesRef = ref(db, "pages");
    return onValue(pagesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const formattedData = Object.keys(data).map((id) => ({
          id,
          ...data[id],
        }));
        setPages(formattedData);
      } else {
        setPages([]);
      }
    });
  }, []);

  // Add a new page
  const addPage = async (pageData, imageFile) => {
    const pagesRef = ref(db, `pages/${pageData.title.toLowerCase().replace(/\s+/g, "-")}`);

    let imageUrl = "";
    if (imageFile) {
      imageUrl = await uploadFile(imageFile); // Upload the image and get the URL
    }

    const newPageData = {
      ...pageData,
      image: imageUrl,
    };

    await set(pagesRef, newPageData); // Save the page data to Firebase
  };

  // Update an existing page
  const updatePage = async (id, updates, imageFile) => {
    const pageRef = ref(db, `pages/${id}`);

    let imageUrl = updates.image || "";
    if (imageFile) {
      imageUrl = await uploadFile(imageFile); // Upload the image and get the URL
    }

    const updatedPageData = {
      ...updates,
      image: imageUrl,
    };

    await update(pageRef, updatedPageData); // Update the page data in Firebase
  };

  // Delete a page
  const deletePage = async (id) => {
    const pageRef = ref(db, `pages/${id}`);
    await remove(pageRef); // Delete the page data from Firebase
  };

  return (
    <PageDataContext.Provider
      value={{
        pages,
        addPage,
        updatePage,
        deletePage,
      }}
    >
      {children}
    </PageDataContext.Provider>
  );
};

export const usePageData = () => useContext(PageDataContext);